export default __webpack_public_path__ + "d3a6131bf698db2d7c8395a4a099b2fc.webp";